module.exports = __webpack_public_path__ + "static/media/IARC.435e7d76.jpeg";